module.exports = __webpack_public_path__ + "pic/26.099ece73.png";